export default function NotFoundRoute(): JSX.Element {
  return (
    <p>
      Oh no! You are lost in candidates paperwork... please turn back to find
      candidates to contact!
    </p>
  );
}
